export default __webpack_public_path__ + "static/media/file.cde7cdec.png";